module.exports = __webpack_public_path__ + "img/kovan.094d3b83.svg";